import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const API_BASE_URL = 'https://api.iraq-parts.com';

const CartPage = () => {
  const { cartItems, removeFromCart, updateQuantity, getTotalPrice, clearCart } = useCart();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return 'https://via.placeholder.com/100x100?text=No+Image';
    if (imageUrl.startsWith('http')) return imageUrl;
    return `${API_BASE_URL}${imageUrl}`;
  };

  const handleCheckout = () => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    navigate('/checkout');
  };

  if (cartItems.length === 0) {
    return (
      <div className="container mx-auto px-4 py-16 text-center" dir="rtl">
        <h1 className="text-4xl font-bold mb-4">سلة التسوق فارغة</h1>
        <p className="text-gray-600 mb-8">أضف بعض المنتجات للبدء!</p>
        <Link
          to="/products"
          className="bg-primary text-white px-8 py-3 rounded-lg hover:bg-blue-700 inline-block"
        >
          تصفح المنتجات
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8" dir="rtl">
      <h1 className="text-4xl font-bold mb-8">سلة التسوق</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Cart Items */}
        <div className="lg:col-span-2">
          {cartItems.map(item => (
            <div key={item.id} className="bg-white rounded-lg shadow-md p-6 mb-4">
              <div className="flex gap-4">
                <img
                  src={getImageUrl(item.image_url)}
                  alt={item.name}
                  className="w-24 h-24 object-cover rounded"
                />
                
                <div className="flex-1">
                  <h3 className="text-lg font-semibold mb-2">{item.name}</h3>
                  {item.part_number && (
                    <p className="text-sm text-gray-500">رقم القطعة: {item.part_number}</p>
                  )}
                  <p className="text-xl font-bold text-primary mt-2">{(parseFloat(item.price) || 0).toLocaleString()} د.ع</p>
                </div>

                <div className="flex flex-col items-end justify-between">
                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    ✕ حذف
                  </button>
                  
                  <div className="flex items-center border border-gray-300 rounded">
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      className="px-3 py-1 hover:bg-gray-100"
                    >
                      -
                    </button>
                    <span className="px-4 py-1 border-x border-gray-300">
                      {item.quantity}
                    </span>
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      className="px-3 py-1 hover:bg-gray-100"
                    >
                      +
                    </button>
                  </div>
                  
                  <p className="text-lg font-semibold mt-2">
                    {((parseFloat(item.price) || 0) * item.quantity).toLocaleString()} د.ع
                  </p>
                </div>
              </div>
            </div>
          ))}

          <button
            onClick={clearCart}
            className="text-red-500 hover:text-red-700 font-semibold"
          >
            إفراغ السلة
          </button>
        </div>

        {/* Order Summary */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-lg shadow-md p-6 sticky top-4">
            <h2 className="text-2xl font-bold mb-4">ملخص الطلب</h2>
            
            <div className="space-y-2 mb-4">
              <div className="flex justify-between">
                <span>المجموع الفرعي:</span>
                <span className="font-semibold">{(getTotalPrice() || 0).toLocaleString()} د.ع</span>
              </div>
            </div>
            
            <div className="border-t pt-4 mb-6">
              <div className="flex justify-between text-xl font-bold">
                <span>المجموع:</span>
                <span className="text-primary">
                  {(getTotalPrice() || 0).toLocaleString()} د.ع
                </span>
              </div>
            </div>
            
            <button
              onClick={handleCheckout}
              className="w-full bg-primary text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-blue-700"
            >
              متابعة إلى إتمام الشراء
            </button>
            
            <Link
              to="/products"
              className="block text-center text-primary hover:underline mt-4"
            >
              ← متابعة التسوق
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
